// components/MessageSnackbar.js

import React, { useEffect } from "react";
import { useSnackbar, SnackbarProvider } from "notistack";
import emitter from "./emmiter";
import Close from "@mui/icons-material/Close";

const Snackbar = () => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    emitter.on("SHOW_NOTIFICATION", (e) => handleSnackEvent(e));

    return () => {
      emitter.off("SHOW_NOTIFICATION");
    };
  }, []);

  /**
   * Handle Snack Event
   *
   * @param {Object}
   */
  const handleSnackEvent = ({ detail }) => {
    const { message, type } = detail;

    const configs = {
      variant: type,
      persist: false,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    };
    console.log(message, configs);
    enqueueSnackbar(message, configs);
  };

  return null; // Snackbar is managed internally
};

/**
 * Add action to all snackbars
 */
const notistackRef = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key);
};

const SnackbarLayout = ({ children }) => {
  return (
    <div>
      <SnackbarProvider
        preventDuplicate
        maxSnack={50}
        ref={notistackRef}
        action={(key) => (
          <Close
            fontSize="small"
            sx={{ cursor: "pointer" }}
            onClick={onClickDismiss(key)}
          />
        )}
      >
        <Snackbar />
      </SnackbarProvider>

      <main>{children}</main>
    </div>
  );
};

export default SnackbarLayout;
